export function getAdjustmentTypeOptions() {
  return [
    {
      value: "SET",
      translation: "set.value",
      text: "Set Value",
    },
    {
      value: "ADD_MINUS",
      translation: "add.minus",
      text: "Add/Substract Value",
    },
  ];
}

export function getAdjustmentFieldOptions() {
  return [
    "byes",
    "draws",
    "drawsAway",
    "drawsHome",
    "forfeitsGiven",
    "forfeitsWonBy",
    "highestScoreAgainst",
    "highestScoreAgainstAway",
    "highestScoreAgainstHome",
    "highestScoreFor",
    "highestScoreForAway",
    "highestScoreForHome",
    "losses",
    "lossesAway",
    "lossesHome",
    "lowestScoreAgainst",
    "lowestScoreAgainstAway",
    "lowestScoreAgainstHome",
    "lowestScoreFor",
    "lowestScoreForAway",
    "lowestScoreForHome",
    "percentage",
    "percentageAway",
    "percentageHome",
    "played",
    "playedAway",
    "playedHome",
    "pointDifference",
    "pointDifferenceAway",
    "pointDifferenceHome",
    "position",
    "scoredAgainst",
    "scoredAgainstAway",
    "scoredAgainstHome",
    "scoredFor",
    "scoredForAway",
    "scoredForHome",
    "standingPoints",
    "standingPointsAway",
    "standingPointsHome",
    "streak",
    "streakAway",
    "streakHome",
    "washouts",
    "winPercentage",
    "winPercentageAway",
    "winPercentageHome",
    "wins",
    "winsAway",
    "winsHome",
  ].map((v) => ({ value: v, translation: v }));
}
